export default __webpack_public_path__ + "d58f73b092e74c3a26586f5bd40a4176.png";